import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from '@/views/components/productManager/style.vue';
import { IPSService } from '@/services/ipsServices';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class AddArea extends IPSDialog {
  title = '添加区域';

  width = '520px';

  data: ItemObject = {
    node: '',
    latitude: 0,
    longitude: 0,
    maxKm: '',
    latAndlong: '',
  };

  rules = {
    node: [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    latAndlong: [{ required: true, message: ' ', validator: this.validatorPosition, trigger: ['blur', 'change'] }],
    maxKm: [{ required: true, message: ' ', validator: this.validatorMaxKm, trigger: ['blur', 'change'] }],
  };

  $refs: {
    areaForm: ElForm;
  };

  mounted() {
    !this.data.node
      && (this.data = {
        node: '',
        latitude: 0,
        longitude: 0,
        maxKm: 0,
        latAndlong: '',
      });
  }

  validatorPosition(rul, val: string, callback) {
    if (!val || !(`${val}`).trim() || val.split(',').length != 2 || !this.isNumber(val.split(',')[0]) || !this.isNumber(val.split(',')[1])) {
      callback(new Error(' '));
    } else {
      callback();
    }
  }

  validatorMaxKm(rul, val: string, callback) {
    if (!val || !(`${val}`).trim() || !this.isNumber(val)) {
      callback(new Error(' '));
    } else if (Number(val) > 999) {
      this.$message.warning('距离最大999');
      callback(new Error(' '));
    } else {
      callback();
    }
  }

  /**
   * 判断数字
   * @param {string} str
   * @returns null
   */
  isNumber(str: string): boolean {
    return Number(str) > 0 || Number(str) < 0 || Number(str) === 0;
  }

  beforeConfirm() {
    this.$refs.areaForm.validate((result) => {
      if (result) {
        this.data.latitude = this.data.latAndlong.split(',')[1];
        this.data.longitude = this.data.latAndlong.split(',')[0];
        this.data.maxKm = Number(this.data.maxKm);
        this.$emit('result', this.data);
        this.$emit('hidden');
      } else {
        this.confirmloading = false;
      }
    });
  }

  renderContent(h) {
    return (
      <el-form props={{ model: this.data }} show-message={false} rules={this.rules} label-width="100px" label-position="left" ref="areaForm" class="add-coupons-form" style="padding: 12px 32pxaa">
        <el-form-item label="区域名称" prop="node">
          <el-input class="wid-125" v-model={this.data.node} show-word-limit maxlength={10} />
        </el-form-item>
        <el-form-item label="经纬度" prop="latAndlong">
          <el-input class="wid-125 inline-block r-mr-12" v-model={this.data.latAndlong} placeholder="示例: 121.477898,31.244454" />
          <a href="http://api.map.baidu.com/lbsapi/getpoint/index.html?qq-pf-to=pcqq.discussion" target="_blank" class="scopeSpan q-link">
            拾取经纬度
          </a>
        </el-form-item>
        <el-form-item label="周边距离" prop="maxKm">
          <el-input class="wid-50 r-mr-12" v-model={this.data.maxKm} placeholder="最大999" />
          <span>Km</span>
        </el-form-item>
      </el-form>
    );
  }
}
